import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MainService } from '../main.service';
import { map, Observable, of } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { UserType, UserTypeEnum } from '../../types';
import { GlobalDataService } from '../global-data/global-data.service';
import { SamSessionService } from './sam-session.service';

export type RawAuthResponse = {
  id: number;
  userId: string;
  displayName: string;
  userType: UserTypeEnum;
  sessionVersion: string;
  csrfToken: string;
  expiresAt: string;
  store: import('../../types').Store | null;
  roles?: string[];
  editorStoreIds?: number[];
  matchedStoreId?: number | null;
};

export type AuthResponse = {
  userId: number;
  externalId: string;
  displayName: string;
  userType: UserTypeEnum;
  generation?: number;
};
export type ExpectedSamSession = { expectedUserId?: number; expectedSessionVersion?: string };

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private http: HttpClient,
    private mainService: MainService,
    private globalData: GlobalDataService,
    private samSession: SamSessionService
  ) {}

  authenticateToken(token: string, expected: ExpectedSamSession = {}): Observable<AuthResponse | null> {
    if (token?.trim()) {
      const generation = this.globalData.beginAuthentication();
      const bearerToken = token.replace(/^Bearer\s+/i, '').trim();
      return this.http
        .post<RawAuthResponse>(
          this.mainService.getApiURL() + 'User/Authenticate',
          expected,
          {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearerToken}`,
            }),
            withCredentials: true,
          }
        )
        .pipe(
          map((response: RawAuthResponse): AuthResponse | null => {
            if (!this.globalData.isAuthenticationCurrent(generation)) return null;
            let userType: UserTypeEnum = UserType.Unknown;
            if (response.userType === UserType.ActiveDirectory) {
              userType = UserType.ActiveDirectory;
            } else if (response.userType === UserType.AgillicAdvisor) {
              userType = UserType.AgillicAdvisor;
            }
            this.samSession.authenticated(response);
            return {
              userId: response.id,
              externalId: response.userId,
              displayName: response.displayName,
              userType: userType,
            };
          }),
          map(authResponse => authResponse ? { ...authResponse, generation } : null)
        );
    } else {
      return of(null);
    }
  }
}
